export default {
  namespaced: true,
  state: {
    // 公募买入
    buyStepId: 1, // 步骤
    buyFormObj: {}, // 表单
    buyResult: {}, // 结果
    // 公募赎回
    currRedeStepId:  1, // 步骤
    redeObj: {}, // row
    fundRedeObj: {}, // 表单详情
    redeResult: {}, // 结果
    // 公募转换
    currTransStepId: 1, // 步骤
    transObj: {}, // row
    transFormObj: {}, // 表单详情
    transResult: {}, // 结果
    // 文件下单
    fileStepId: 1, // 步骤
    fileCheckedList: {}, // 文件下单已选择列表
    fileOrderResult: {}, // 结果
    fileProtocalObj: {}, // 信披留痕
    // 智能拆单
    splitOrderList: {}, // 列表
    currSplitStepId: 1, // 步骤
    splitApplyList: [], // 智能拆单实时列表
    splitRemitBankList: {}, // 关联账户列表
    splitResult: {}, // 拆单结果
    splitAgreeObj: {},
    // 批量买入
    bulkStepId: 1, // 步骤
    bulkSelectedList: [], // 批量买入选中的基金列表
    bulkResult: {}, // 批量买入结果
    // 批量赎回
    bulkRedeemStepId: 1, // 步骤
    bulkRedeemSelectedList: [], //
    bulkRedeemResult: {},
  },
  mutations: {
    setBuyStepId(state, params) {
      state.buyStepId = params
    },
    setBuyFormObj(state, params) {
      state.buyFormObj = params
    },
    setBuyResult(state, params) {
      state.buyResult = params
    },
    clearBuyList(state, params) {
      state.buyStepId = 1
      state.buyFormObj = {}
      state.buyResult = {}
    },
    setCurrRedeStep(state, params) {
      state.currRedeStepId = params
    },
    setRedeObj(state, params) {
      state.redeObj = params
    },
    setFundRedeObj(state, params) {
      state.fundRedeObj = params
    },
    setRedeResult(state, params) {
      state.redeResult = params
    },
    clearRedeList(state, params) {
      state.currRedeStepId = 1
      state.redeObj = {}
      state.fundRedeObj = {}
      state.redeResult = {}
    },
    setCurrTransStep(state, params) {
      state.currTransStepId = params
    },
    setTransObj(state, params) {
      state.transObj = params
    },
    setTransFormObj(state, params) {
      state.transFormObj = params
    },
    clearTransList(state, params) {
      state.currTransStepId = 1
      state.transObj = {}
      state.transFormObj = {}
    },
    setFileStepId(state, params) {
      state.fileStepId = params
    },
    setFileCheckedList(state, params) {
      state.fileCheckedList = params
    },
    setFileOrderResult(state, params) {
      state.fileOrderResult = params
    },
    setFileProtocalObj(state, params) {
      state.fileProtocalObj = params
    },
    clearFileCheckedList(state, params) {
      state.fileCheckedList = {}
    },
    clearFileOrderList(state, params) {
      state.fileStepId = 1
      state.fileOrderResult = {}
      state.fileProtocalObj = {}
    },
    setCurrSplitStepId(state, params) {
      state.currSplitStepId = params
    },
    setSplitOrderList(state, params) {
      state.splitOrderList = params
    },
    setSplitApplyList(state, params) {
      state.splitApplyList = params
    },
    setSplitRemitAccoList(state, params) {
      state.splitRemitBankList = params
    },
    setSplitResult(state, params) {
      state.splitResult = params
    },
    setSplitAgreeObj(state, params) {
      state.splitAgreeObj = params
    },
    clearSplitList(state, params) {
      state.currSplitStepId = 1
      state.splitOrderList = {}
      state.splitApplyList = []
      state.splitRemitBankList = {}
      state.splitResult = {}
      state.splitAgreeObj = {}
    },
    setBulkStepId(state, params) {
      state.bulkStepId = params
    },
    clearBulkStepId(state, params) {
      state.bulkStepId = 1
    },
    setBulkSelectedList(state, params) {
      state.bulkSelectedList = params
    },
    setBulkResult(state, params) {
      state.bulkResult = params
    },
    clearBulkList(state, params) {
      state.bulkSelectedList = [];
      state.bulkResult = {}
    },
    setBulkRedeemStepId(state, params) {
      state.bulkRedeemStepId = params
    },
    clearBulkRedeemStepId(state, params) {
      state.bulkRedeemStepId = 1
    },
    setBulkRedeemSelectedList(state, params) {
      state.bulkRedeemSelectedList = params
    },
    setBulkRedeemResult(state, params) {
      state.bulkRedeemResult = params
    },
    clearBulkRedeemList(state, params) {
      state.bulkRedeemSelectedList = [];
      state.bulkRedeemResult = {}
    },
  },
  actions: {
    getBuyStepId ({commit}, params) {
      commit('setBuyStepId', params)
    },
    getBuyFormObj({commit}, params) {
      commit('setBuyFormObj', params)
    },
    getBuyResult({commit}, params) {
      commit('setBuyResult', params)
    },
    getCurrRedeStep({commit}, params) {
      commit('setCurrRedeStep', params)
    },
    getRedeObj({commit}, params) {
      commit('setRedeObj', params)
    },
    getFundRedeObj({commit}, params) {
      commit('setFundRedeObj', params)
    },
    getRedeResult({commit}, params) {
      commit('setRedeResult', params)
    },
    getCurrTransStep({commit}, params) {
      commit('setCurrTransStep', params)
    },
    getTransObj({commit}, params) {
      commit('setTransObj', params)
    },
    getTransFormObj({commit}, params) {
      commit('setTransFormObj', params)
    },
    getFileStep({commit}, params) {
      commit('setFileStepId', params)
    },
    getFileOrderResult({commit}, params) {
      commit('setFileOrderResult', params)
    },
    getFileProtocalObj({commit}, params) {
      commit('setFileProtocalObj', params)
    },
    getFileCheckedList({commit}, params) {
      commit('setFileCheckedList', params)
    },
    getCurrSplitStepId({commit}, params) {
      commit('setCurrSplitStepId', params)
    },
    getSplitOrderList({commit}, params) {
      commit('setSplitOrderList', params)
    },
    getSplitApplyList({commit}, params) {
      commit('setSplitApplyList', params)
    },
    getSplitRemitAccoList({commit}, params) {
      commit('setSplitRemitAccoList', params)
    },
    getSplitResult({commit}, params) {
      commit('setSplitResult', params)
    },
    getSplitAgreeObj({commit}, params) {
      commit('setSplitAgreeObj', params)
    },
    getBulkStepId ({commit}, params) {
      commit('setBulkStepId', params)
    },
    getBulkSelectedList({commit}, params) {
      commit('setBulkSelectedList', params)
    },
    getBulkResult({commit}, params) {
      commit('setBulkResult', params)
    },
    getBulkRedeemStepId ({commit}, params) {
      commit('setBulkRedeemStepId', params)
    },
    getBulkRedeemSelectedList({commit}, params) {
      commit('setBulkRedeemSelectedList', params)
    },
    getBulkRedeemResult({commit}, params) {
      commit('setBulkRedeemResult', params)
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/trade.js